import { isCentralHost, workspaceSlugOf } from "../../shared/hosts";

/**
 * Where this page is: the central host, where people sign in and choose a workspace, or a workspace's
 * own host, `<slug>.<ROOT_DOMAIN>`, where its console is (Impa docs/PLATFORM_CONVENTIONS.md, rules 2
 * and 8). A page never changes host, so these are read from the address, not kept.
 */
const ROOT_DOMAIN = import.meta.env.VITE_ROOT_DOMAIN;

function here(): URL {
  return new URL(window.location.href);
}

/** The workspace whose host this page is on, by its slug, or null on the central host. */
export function currentWorkspaceSlug(): string | null {
  return workspaceSlugOf(ROOT_DOMAIN, here());
}

export function onCentralHost(): boolean {
  return isCentralHost(ROOT_DOMAIN, here());
}

/**
 * The workspace in view, on a page rendered only on a workspace's host (routes/admin.tsx renders
 * none of its pages anywhere else).
 */
export function workspaceSlug(): string {
  const slug = currentWorkspaceSlug();
  if (slug === null) throw new Error("not_a_workspace_host");
  return slug;
}

/** An address on the central host, on this page's scheme. */
export function centralUrl(path: string): string {
  return `${window.location.protocol}//${ROOT_DOMAIN}${path}`;
}

/**
 * Signing in, which starts on the central host (Impa returns the browser there), and then comes back
 * to `returnTo`, this page unless said otherwise. The central host's sign-in takes only Link's own
 * addresses back; anything else returns to the list of workspaces.
 */
export function signInUrl(returnTo: string = window.location.href): string {
  return `${centralUrl("/auth/id/login")}?return_to=${encodeURIComponent(returnTo)}`;
}
